// LinkCard.jsx
import React from 'react';

const LinkCard = ({ label, billType, stat, currentMonth, currentYear }) => {
    function getMonthName(monthNumber) {
        const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
      
        // Adjust for 0-based indexing
        return monthNames[monthNumber - 1] || "Invalid Month";
      }
    return (
      <div className="flex flex-col w-[150px] h-[150px] bg-gradient-to-r from-blue-400 to-blue-200 text-gray-800 p-2 rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-400 hover:text-white transition-all cursor-pointer items-center justify-center text-center text-xs">
        <p className="font-semibold">{label}</p>
  
        {billType && billType && stat &&['gst', 'retail', 'cashmemo'].includes(billType.toLowerCase()) && stat[billType] && (
          <>
            <div className="flex flex-col items-center mt-3">
              <p>{`${getMonthName(currentMonth)}, ${currentYear}`}</p>
            </div>
            <div className="flex flex-col items-center">
              <p>{`${stat[billType].bill} bills`}</p>
            </div>
            <div className="flex flex-col items-center">
              <p>{`${stat[billType].amount.toLocaleString('en-IN')} Rupees`}</p>
            </div>
          </>
        )}
      </div>
    );
  };
  

export default LinkCard;
